import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ClientEnglishFallback } from "../../../constant/ClientEnglishFallback";

function OtherFileViewer({ file, showDetails }) {
  const { selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const [fileSize, setFileSize] = useState(null);
  const LANGUAGE = ClientEnglishFallback.OtherFileViewer(multiLanguageData?.OtherFileViewer || {})
  const {
    TEXT_NO_PREVIEW,
    BUTTON_OPEN
  } = LANGUAGE;
  useEffect(() => {
    const checkFileSize = async () => {
      try {
        const response = await fetch(file.fileUrl, { method: "HEAD" });
        const size = response.headers.get("content-length");
        setFileSize(parseInt(size));
      } catch (error) {
        console.error("checkFileSize-> Error checking file size: ", error);
      }
    };
    checkFileSize();
  }, [file.fileUrl]);

  const handleOpenFile = async () => {
    try {
      const response = await fetch(file.fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = file.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("handleOpenFile-> Error downloading file: ", error);
    }
  };

  return (
    <Box>
      <Box sx={{ alignItems: "center",  justifyContent: "center",  display: "flex" }}  >
        <Box
          sx={{
            backgroundColor: "grey",
            width: "300px",
            padding: "10px",
            borderRadius: "8px",
          }}
        >
          <Typography variant="h6" component="div" gutterBottom>
            {TEXT_NO_PREVIEW}
          </Typography>
          <InsertDriveFileIcon sx={{ fontSize: "50px" }} />
          <Typography variant="body1" component="div" gutterBottom>
            {file?.name}
          </Typography>
          {showDetails && (
            <Typography variant="body2" component="div" gutterBottom>
              {moment(file?.dateCreated).format("YYYY-MM-DD")}
            </Typography>
          )}
          {showDetails && (
            <Button
              sx={{
                backgroundColor: selectedClientData?.AccentColor,
                marginTop: 2,
                color: "white",
                borderRadius: "8px",
              }}
              onClick={handleOpenFile}
            >
              {BUTTON_OPEN}
            </Button>
          )}
        </Box>
      </Box>
      {showDetails && (
        <Stack sx={{ mt: 0.5, wordSpacing: 1,
            lineHeight: "0.9rem",
            overflow: "scroll",
            scrollbarWidth: "none", }} onClick={(e) => { }}
        >
          <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction={"row"} className="other-stack-adjust">
            <Stack direction={"row"}  sx={{ gap: 1, alignItems: "center" }}>
              <Avatar alt="Remy Sharp" src={file?.userProfilePicture} />
              <Typography>{file?.userName}</Typography>
            </Stack>
            <Typography>
              {moment(file?.dateCreated).format("MMMM DD, YYYY")}
            </Typography>
          </Stack>
          <Typography
            maxHeight={"100px"}
            overflow={"scroll"}
            variant="body2"
            sx={{ mt: 1 }}
          >
            {file?.description}
          </Typography>
        </Stack>
      )}
    </Box>
  );
}

export default OtherFileViewer;
